<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  // 2.0兼容IE
  import 'babel-polyfill'

  import api from '../src/api/account.js'
  import auth from './utils/auth'
  import {mapMutations} from 'vuex'

  const FALLTHROUGH_PATHS_PATTERN = /\/(reset|password|login).*/i

  export default {
    name: 'app',
    data () {
      return {}
    },
    methods: {

      ...mapMutations([
        'loggingStatus',
        'testPlatform',
        'checkIP'
      ]),

      getCookies () {
        let currentPath = this.$router.currentRoute.path;
        if (!FALLTHROUGH_PATHS_PATTERN.test(currentPath)) {
          let userEmail = auth.getCookie('userEmail');
          let nextHop;
          if (userEmail) {
            nextHop = userEmail === 'facebook' ? '/login#facebook' : '/login'
          } else {
            nextHop = '/signup'
          }
          this.$router.push(nextHop)
        } else {
          // do nothing to fallthrough
        }
      },
      checkUrl () {
        if (!location.href.includes('direct')) {
          this.getCookies()
        }
      },
      preventDefaults () {
        document.addEventListener('mousemove', (e) => {
          e.preventDefault()
        }, false)
      }
    },
    mounted () {
      this.testPlatform()
      this.checkIP()
      api.getToken({version: Math.random()})
      this.checkUrl()
      this.loggingStatus()
      this.preventDefaults()
    }
  }
</script>
<style>
  html, body {
    width: 100%;
    height: 100%;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue